<template>
  <div class="baseindivs">
    <b-container fluid="xxl">
      <b-row>
        <b-col id="select-baseindiv">
          <b-form-group
            id="baseindiv"
            label="Base Indiv:"
            label-for="baseindiv"
          >
            <Select2 @select="select($event)" :settings="selectConfig" ref="select2" tabindex="0" />
          </b-form-group>

          <b-form-group
            id="ordering"
            label="Ordering:"
            label-for="ordering"
            v-if="showOrdering"
          >
            <b-form-input
              id="ordering"
              v-model="ordering"
              placeholder="Ordering"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-new-base-indiv" title="New Base Indiv" ok-title="Save" @ok="saveNew" >
      <BaseIndivNewEdit :baseindiv="{'form': this.query}" />
    </b-modal>
  </div>
</template>

<script>
import HelpStore from "@/store/helpstore.js";
import Select2 from 'v-select2-component';
import BaseIndivNewEdit from "@/components/Scripta/BaseIndivNewEdit.vue";
import config from '@/config.js';

export default {
  name: "BaseIndivAutocomplete",
  props: ["exclude", "baseIndiv", "showOrdering", "headId", "allowNew", "orderingNum", "parentId"],
  data() {
    return {
      query: "",
      timer: null,
      baseIndivObj: this.baseIndiv,
      parentIdElem: this.parentId ? this.parentId : "select-baseindiv",
      ordering: this.baseIndiv ? this.baseIndiv.ordering : (this.orderingNum ? this.orderingNum : 1),
      index: this.baseIndiv ? this.baseIndiv._index : null,
      showAddNew: this.allowNew == false ? false : true,
    };
  },
  components: {
    Select2,
    BaseIndivNewEdit,
  },
  methods: {
    select(event){
      if (event.selected && event.id == -2){
        this.$bvModal.show("modal-new-base-indiv")
      }
      else {
        this.baseIndivObj = event.selected ? event.baseIndiv : null
        this.$emit("select", this.baseIndivObj)
        this.update()
      }
    },
    saveNew(){
      this.$store.dispatch('createBaseindiv', HelpStore.item).then((response) => {
        this.baseIndivObj = response.data
        this.$refs.select2.select2.append(
          `<option selected value="${this.baseIndivObj.id}">${this.baseIndivObj.form}</option>`
        ).trigger('change')
        HelpStore.item = this.baseIndivObj
      })
    },
    update(){
      if (this.baseIndivObj){
        this.baseIndivObj["ordering"] = this.ordering;
        this.baseIndivObj["_index"] = this.index;
        HelpStore.item = this.baseIndivObj;
      }
    },
  },
  updated() {
    this.update()
  },
  mounted() {
    if (this.baseIndiv){
      this.$refs.select2.select2.append(
        `<option selected value="${this.baseIndiv.id}">${this.baseIndiv.form}</option>`
      ).trigger('change')
    }
  },
  computed: {
    selectConfig(){
      return {
        placeholder: "Select a base indiv",
        // allowClear: this.allowClear == false ? false : true,
        width: '100%',
        dropdownParent: `#${this.parentIdElem}`,
        templateSelection: (val) => {
          return val.form ? val.form : val.text
        },
        ajax: {
          delay: 250,
          url: config.apiUrl + '/baseindivs/autocomplete',
          headers: config.apiHeaders,
          data: (params) => {
            this.query = params.term
            return {
              query: params.term,
              // headId: this.headId,
              exclude: JSON.stringify(this.exclude),
            }
          },
          processResults: (data) => {
            if (data.length == 0 && this.showAddNew && this.query){
              data.push({
                id: -2,
                form: `Create new "${this.query}"`
              })
            }
            return {
              results: data.map(baseIndiv => {
                let text = baseIndiv.form
                let orderNum = 0
                if (baseIndiv.id != -2 && !baseIndiv.heads.map(head => head.id).includes(this.headId)) {
                  text = `${text} (not connected to head)`
                  orderNum = 1
                }
                return {
                  id: baseIndiv.id,
                  text: text,
                  orderNum: orderNum,
                  form: baseIndiv.form,
                  baseIndiv: baseIndiv
                }
              }).sort((a, b) => a.orderNum - b.orderNum)
            }
          }
        }
      }
    }
  },
};
</script>
